import { createFileRoute } from "@tanstack/react-router";
import { getLegalPages } from "@/lib/legal.functions";
import { LegalPageView, legalMeta } from "@/components/site/legal/LegalPage";

export const Route = createFileRoute("/privacidad")({
  loader: () => getLegalPages({ data: { lang: "es" } }),
  head: ({ loaderData }) =>
    loaderData
      ? legalMeta(loaderData.pages.privacy, "/privacidad")
      : { meta: [{ title: "Política de Privacidad — Bizaclia.com" }] },
  component: PrivacidadPage,
});

function PrivacidadPage() {
  const data = Route.useLoaderData();
  return <LegalPageView page={data.pages.privacy} operator={data.operator} />;
}
